import { useStoreOoloja } from "@/stores/ooloja";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const storeOoloja = useStoreOoloja();

  if (process.server) return;

  if (storeOoloja?.erp?.on == false) {
    navigateTo("/", { external: true });
  }

});
